/* tslint:disable */
/* eslint-disable */

/**
 * 0 = DoorToDoor
 * 
 * 1 = DoorToPort
 * 
 * 2 = Clearance
 * 
 * 3 = Groupage
 * 
 * 4 = CustomerCollect
 */
export enum FreightTerm {
  DoorToDoor = 0,
  DoorToPort = 1,
  Clearance = 2,
  Groupage = 3,
  CustomerCollect = 4
}
